/* global axios */
import ApiClient from './ApiClient';

class TicketFormsAPI extends ApiClient {
  constructor() {
    super('ticket_forms', { accountScoped: true });
  }
}

export default new TicketFormsAPI();
